import { Box, Typography } from '@mui/material'
import AreasAndZones from '@/features/config/pages/AreasAndZones'
import useTranslation from '@/hooks/useTranslation'
import type { GuidedStepComponentProps } from '../guidedSteps'

// SCRUM-1032 / SCRUM-1039 — guided-setup step for Areas & Sub-Areas.
// Embeds the refined Areas config grid, scoped to the setup interface id
// (never the globally-selected interface — SCRUM-976). The `titleSlot`/embedded
// mode of AreasAndZones already omits ConfigLayout + StatusInterface, so it can
// sit directly inside the guided-setup panel.
const AreasStep = ({ interfaceId }: GuidedStepComponentProps) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ height: '100%', p: '32px' }}>
      <AreasAndZones
        interfaceId={interfaceId}
        titleSlot={
          <Typography
            sx={{ color: 'text.main', fontSize: '18px', fontWeight: 700 }}
          >
            {t('menuStationConfigAreasSubAreas')}
          </Typography>
        }
      />
    </Box>
  )
}

export default AreasStep
